"use client"

import { useEffect, useState } from "react"

export default function ThemeToggle() {
  const [isDark, setIsDark] = useState(true)

  useEffect(() => {
    const stored = localStorage.getItem("cyber-theme")
    if (stored === "light") setIsDark(false)
  }, [])

  const toggle = () => {
    const next = !isDark
    document.documentElement.classList.toggle("dark", next)
    localStorage.setItem("cyber-theme", next ? "dark" : "light")
    setIsDark(next)
  }

  return (
    <button
      onClick={toggle}
      className="p-2 rounded-full hover:bg-gray-200 transition-colors text-base leading-none"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDark ? "🌙" : "☀️"}
    </button>
  )
}
